import { useEffect, useRef, useState } from "react";
import { FaDownload } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { MdDelete } from "react-icons/md";
import imageCompression from 'browser-image-compression';

import WhiteUploadButton from "src/Components/Common/whiteuploadbutton";
import { setPONumber } from "src/Redux/Slices/HeaderSlice";
import WOService from "src/Services/API/wo.service";
import PONumberAddModal from "./Components/ponumberaddmodal";
import ConfirmDialog from "src/Common/confirmdialog";
import AttachmentImageSlider from "../WO/Components/attachment/AttachmentImageSlider";

import {
  formatDate,
  getAvatarUrl,
  getImageUrl,
  getPOReceiptUrl,
  getRealFileName,
  getUploadUrl,
} from "src/Common/common";

// import ApproveRequestButton from "./Components/CreateModal/approverequestbutton";
// import DenyRequestButton from "./Components/CreateModal/denyrequestbutton";
import UserService from "src/Services/API/user.service";
// import AssignTechModal from "./Components/AssignTech/assigntechmodal";
// import ScheduleModal from "./Components/ScheduleModal";
import { paymentItems } from "src/Common/contants";
import {
  can,
  downloadImage,
  downloadPdf,
  handleError,
} from "src/Common/function";
import ApproveRequestButton from "src/Components/Common/approverequestbutton";
import DenyRequestButton from "src/Components/Common/denyrequestbutton";
import PencilButton from "src/Components/Common/pencilbutton";
import POService from "src/Services/API/po.service";
import CreatePoModal from "../WO/Components/createpomodal/CreatePoModal";
import POStatusComponent from "./Components/Status/postatuscomponent";
import BlueButton from "src/Components/Common/bluebutton";
import DownloadPdfbutton from "src/Pages/PO/Components/downloadpdfbutton";
import CompleteButton from "./Components/completebutton";

function PODetail() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const [order, setOrder] = useState(location.state?.order ?? null);
  const [user] = useState(UserService.getCurrentUser());
  const inputFile = useRef(null);
  const [currentUser] = useState(UserService.getCurrentUser());
  const [poNumberModalShown, setPoNumberModalShown] = useState(false);
  const [cratePOModalShown, setCratePOModalShown] = useState(false);
  const [isReceiptDownloading, setIsReceiptDownloading] = useState(false);
  const [isCompleting, setIsCompleting] = useState(false);
  //uploading attachment
  const receiptInputFile = useRef(null);
  const receiptDragCounter = useRef(0);

  //attachment preview
  const [isAttachmentSliderShown, setIsAttachmentSliderShown] = useState(false);
  const [sliderAttachments, setSliderAttachments] = useState([]);
  const [sliderActiveIndex, setSliderActiveIndex] = useState(0);

  //attachment delete confirmation
  const [attachmentDeleteModalShown, setAttachmentDeleteModalShown] = useState(false);
  const [attachmentToDeleteId, setAttachmentToDeleteId] = useState(null);

  const [isUploadingReceipt, setIsUploadingReceipt] = useState(false);
  const [isReceiptDragActive, setIsReceiptDragActive] = useState(false);
  const [isReceiptDragInvalid, setIsReceiptDragInvalid] = useState(false);

  useEffect(() => {
    getPurchaseOrder();
  }, []);

  const getPurchaseOrder = () => {
    const poId = id ?? order?.id;
    if (!poId) return;
    POService.getPurchaseOrdersByPoId(poId)
      .then((response) => {
        if (response.status == 200) {
          setOrder(response.data);
          dispatch(setPONumber(String(response.data.number)));
        }
      })
      .catch((error) => handleError(error));
  };

  const denyRequest = () => { };

  const showPoInputModal = () => {
    // setPoNumberModalShown(true);
    approveRequest();
  };

  const approveRequest = () => {
    POService.update({
      id: order.id,
      data: {
        issuedUser: currentUser.id,
        status: 2,
        issuedDate: new Date(),
      },
    })
      .then((response) => {
        if (response.status == 201) {
          //if this is first po, set the status of wo to "parts"
          if (response.data.wo?.pos?.length === 1) {
            WOService.update({ id: response.data.wo.id, data: { status: 4 } })
              .then((response) => {
                if (response.status == 201) {
                  console.log("status updated to 'Parts' successfully");
                }
              })
              .catch((error) => {
                handleError(error);
              });
          }
          console.log("approve po reqeuest response.data: ", response.data);
          setOrder(response.data);
          dispatch(setPONumber(response.data.number));
          toast("Purchase order approved");
        }
      })
      .catch((error) => {
        handleError(error);
      });
    // setPoNumberModalShown(false);
  };

  const editPO = () => {
    setCratePOModalShown(true);
  };

  // Closes the modal only on success — on failure it stays open (with the
  // user's input intact) so the submit can be retried.
  const savePO = async (data) => {
    try {
      //upload receipts
      // for (let file of data.data.receipts) {
      //   const fileName = `PO receipt_${String(Math.floor(Date.now()))}.png`;
      //   const fileData = { id: data.id, name: fileName, base64: file.base64 };
      //   console.log(fileData);
      //   await POService.attachFile(fileData);
      // }

      //save data
      let response = await POService.update(data);
      if (response.status == 201) {
        setCratePOModalShown(false);
        toast("Purchase order updated successfully!");
        setOrder(response.data);
      }
    } catch (error) {
      handleError(error);
    }

    getPurchaseOrder();
  };

  const resetReceiptDragState = () => {
    receiptDragCounter.current = 0;
    setIsReceiptDragActive(false);
    setIsReceiptDragInvalid(false);
  };

  const isAllowedReceiptFile = (file) => {
    if (!file) return false;
    const type = (file.type || "").toLowerCase();
    if (type.startsWith("image/") || type === "application/pdf") return true;
    const name = (file.name || "").toLowerCase();
    return /\.(png|jpe?g|gif|bmp|webp|svg|heic|heif|tiff?|pdf)$/.test(name);
  };

  const isAllowedReceiptDragType = (type = "") => {
    const t = type.toLowerCase();
    return t.startsWith("image/") || t === "application/pdf";
  };

  const hasInvalidDragItems = (dataTransfer) => {
    if (!dataTransfer) return false;
    const items = dataTransfer.items ? Array.from(dataTransfer.items) : [];
    const fileItems = items.filter((item) => item.kind === "file");
    if (fileItems.length === 0) return false;
    return fileItems.some((item) => !isAllowedReceiptDragType(item.type));
  };

  const filterAllowedReceiptFiles = (files = []) => {
    const allowed = [];
    let rejectedCount = 0;
    files.forEach((file) => {
      if (isAllowedReceiptFile(file)) {
        allowed.push(file);
      } else {
        rejectedCount += 1;
      }
    });
    if (rejectedCount > 0) {
      toast(
        `${rejectedCount} file${rejectedCount > 1 ? "s were" : " was"} skipped. Only images and PDFs are allowed.`
      );
    }
    return allowed;
  };

  const handleReceiptFiles = async (files = []) => {
    const options = {
      maxSizeMB: 5,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };

    if (files.length === 0) return;

    setIsUploadingReceipt(true);

    try {
      let latestOrder = null;

      for (const file of files) {
        let compressedFile = file;
        const isImage = file.type.startsWith("image/");

        if (isImage && file.size > 5242880) {
          const compressedBlob = await imageCompression(file, options);
          compressedFile = new File(
            [compressedBlob],
            file.name,
            {
              type: compressedBlob.type,
              lastModified: Date.now(),
            }
          );

          console.log("Original:", file.size / 1024 / 1024, "MB");
          console.log("Compressed:", compressedFile.size / 1024 / 1024, "MB");
        }

        const response = await POService.uploadFile(compressedFile, order.id);
        if (response.status == 201) {
          latestOrder = response.data;
        } else {
          toast("Something went wrong");
          return;
        }
      }

      if (latestOrder) {
        setOrder(latestOrder);
      }

      toast(`${files.length} file${files.length > 1 ? "s" : ""} uploaded successfully`);
    } catch (error) {
      handleError(error);
    } finally {
      setIsUploadingReceipt(false);
    }
  };

  const receiptSelected = async (e) => {
    const input = e.target;
    const files = Array.from(input?.files || []);
    await handleReceiptFiles(files);
    if (receiptInputFile.current) {
      receiptInputFile.current.value = null;
    } else if (input) {
      input.value = null;
    }
  };

  const uploadReceipt = () => {
    receiptInputFile.current.click();
  };

  const handleReceiptDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (isUploadingReceipt) return;

    receiptDragCounter.current += 1;
    setIsReceiptDragActive(true);
    setIsReceiptDragInvalid(hasInvalidDragItems(e.dataTransfer));
  };

  const handleReceiptDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (isUploadingReceipt) return;

    setIsReceiptDragActive(true);
    setIsReceiptDragInvalid(hasInvalidDragItems(e.dataTransfer));
  };

  const handleReceiptDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (isUploadingReceipt) return;

    receiptDragCounter.current = Math.max(receiptDragCounter.current - 1, 0);
    if (receiptDragCounter.current === 0) {
      setIsReceiptDragActive(false);
      setIsReceiptDragInvalid(false);
    }
  };

  const handleReceiptDrop = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (isUploadingReceipt || !can("po:update")) return;

    const files = Array.from(e.dataTransfer.files || []);
    resetReceiptDragState();
    const allowedFiles = filterAllowedReceiptFiles(files);
    if (allowedFiles.length === 0) return;
    await handleReceiptFiles(allowedFiles);
  };

  const deleteAttachment = () => {
    setAttachmentDeleteModalShown(false);
    POService.deleteAttachment(attachmentToDeleteId)
      .then((response) => {
        toast("Attachment deleted successfully");
        getPurchaseOrder();
      })
      .catch((error) => {
        handleError(error);
      });
  };

  const openAttachmentSlider = (attachments, activeIndex = 0) => {
    setSliderAttachments(attachments);
    setSliderActiveIndex(activeIndex);
    setIsAttachmentSliderShown(true);
  };

  const getAttachmentPreview = (attachment, options = {}) => ({
    id: options.id || attachment.id || attachment.fileName,
    fileName: attachment.fileName,
    displayName: getRealFileName(attachment.fileName) || attachment.fileName || "Attachment",
    isPdf: attachment.fileName?.toLowerCase().endsWith(".pdf"),
    isReceipt: options.isReceipt || false,
    description: attachment.description,
    tags: attachment.tags,
    createdBy: attachment.createdBy?.name || attachment.createdBy,
    createdAt: attachment.createdAt,
    ...(options.url ? { url: options.url } : {}),
  });

  const previewReceiptAttachment = (clickedAttachment) => {
    const attachments = (order.attachments || []).map((attachment) =>
      getAttachmentPreview(attachment, { isReceipt: true })
    );
    const activeIndex = attachments.findIndex((a) => a.id === clickedAttachment.id);
    openAttachmentSlider(attachments, activeIndex >= 0 ? activeIndex : 0);
  };

  const previewPOItemAttachment = (fileName) => {
    openAttachmentSlider(
      [
        getAttachmentPreview(
          { fileName },
          {
            url: getUploadUrl(fileName),
          }
        ),
      ],
      0
    );
  };

  if (!order) {
    return null;
  }

  return (
    <div className="w-full px-5 ">
      <AttachmentImageSlider
        shown={isAttachmentSliderShown}
        attachments={sliderAttachments}
        activeIndex={sliderActiveIndex}
        onCancel={() => setIsAttachmentSliderShown(false)}
      />
      <PONumberAddModal
        shown={poNumberModalShown}
        onSaveClicked={(poNumber) => approveRequest(poNumber)}
        onCancelClicked={() => setPoNumberModalShown(false)}
      />
      <CreatePoModal
        shown={cratePOModalShown}
        onCancelClicked={() => setCratePOModalShown(false)}
        onSubmitClicked={savePO}
        wo={order.wo}
        editingPO={order}
      />

      <ConfirmDialog
        title="DELETE ATTACHMENT"
        description="Are you sure you want to delete this attachment?"
        shown={attachmentDeleteModalShown}
        onConfirmClicked={deleteAttachment}
        onCancelClicked={() => setAttachmentDeleteModalShown(false)}
      />

      <div className="w-full h-[56px] flex items-center justify-between">
        <div onClick={() => navigate(-1)} className="w-full h-full flex items-center cursor-pointer">
          <img src={getImageUrl("/images/common/back_arrow.png")} className="w-[24px]" />
          <span className="font-OpenSansRegular text-[14px] font-[700] text-subTitleColor">back</span>
        </div>
        {/* <div
          onClick={async () => {
            try {
              const fileURL = getPOReceiptUrl(`PO_Report_${order.number}.pdf`);
              const response = await axios.head(fileURL);
              if (response.status === 200) {
                downloadPdf(getPOReceiptUrl(`PO_Report_${order.number}.pdf`), `PO_Report_${order.number}.pdf`);
              }
            } catch (error) {
            console.log("🚀 PO receipt doesn't exist:", error);

            POService.generatePOReceipt(order.id)
              .then((response) => {
                downloadPdf(getPOReceiptUrl(`PO_Report_${order.number}.pdf`), `PO_Report_${order.number}.pdf`);
              })
              .catch((error) => {
                console.log("🚀 ~ PODetail ~ error:", error);
              });

            // }
          }}
          className="w-[150px] cursor-pointer px-[20px] h-[30px] bg-blueColor rounded-[6px] flex items-center justify-center font-OpenSansRegular font-[600] text-[12px] text-white"
        >
          Download PDF
        </div> */}

        <div className="flex items-center justify-center gap-2">
          <DownloadPdfbutton
            onClicked={() => {
              setIsReceiptDownloading(true);
              POService.generatePOReceipt(order.id)
                .then((response) => {
                  downloadPdf(getPOReceiptUrl(`PO_Report_${order.number}.pdf`), `PO_Report_${order.number}.pdf`);
                })
                .catch((error) => {
                  console.log("🚀 ~ PODetail ~ error:", error);
                })
                .finally(() => {
                  setIsReceiptDownloading(false);
                });
            }}
            isLoading={isReceiptDownloading}
          />
          {can("po:update") && order.status !== 4 && (
            <CompleteButton
              onClicked={() => {
                setIsCompleting(true);
                POService.update({
                  id: order.id,
                  data: { status: 4 },
                  eventUser: UserService.getCurrentUser(),
                })
                  .then((response) => {
                    if (response.status === 201) {
                      getPurchaseOrder();
                    }
                  })
                  .catch((error) => {
                    handleError(error);
                  })
                  .finally(() => {
                    setIsCompleting(false);
                  });
              }}
              isLoading={isCompleting}
            />
          )}
        </div>
      </div>

      <div className="w-full border-solid border-[1px] border-borderColor mt-3 relative">
        <div className="w-full h-[30px]  flex items-center justify-between px-3">
          <span className="font-OpenSansRegular font-[700] text-[16px] text-titleColor ">Purchase Order Details </span>
          <POStatusComponent value={order.status} />
        </div>
        <div className="w-full h-[50px] border-solid border-t-[1px] border-borderColor flex items-center justify-between px-3">
          <div className="w-full flex items-center justify-between">
            <div className="flex items-center gap-1">
              <span className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">PO#: </span>
              <span className="font-OpenSansRegular text-[12px] text-titleColor">{order.number}</span>
            </div>
            <div className="flex items-center gap-1">
              <span className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">WO reference#: </span>
              <span className="font-OpenSansRegular text-[12px] text-titleColor">{order.wo?.number}</span>
            </div>
            <div className="flex items-center gap-1">
              <span className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">Date Added: </span>
              <span className="font-OpenSansRegular text-[12px] text-titleColor">{formatDate(order.createdAt)}</span>
            </div>
            <div className="flex items-center gap-1">
              <span className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">Type: </span>
              <span className="font-OpenSansRegular text-[12px] text-titleColor">
                {paymentItems[order.paymentType]}
              </span>
            </div>
            <div className="flex items-center gap-1">
              <span className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">Customer: </span>
              <span className="font-OpenSansRegular text-[12px] text-titleColor">{order.wo?.customer?.companyName}</span>
            </div>
            <div className="flex flex-col gap-1">
              <div className="flex items-center gap-1">
                {order.issuedUser && order.status >= 2 && (
                  <>
                    <span className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">Issued For: </span>
                    <img
                      src={getAvatarUrl(order.issuedUser.avatar)}
                      className="w-[20px] rounded-[10px] cursor-pointer ml-2"
                    />
                    <span className="font-OpenSansRegular text-[12px] text-titleColor">{order.issuedUser.name}</span>
                  </>
                )}
              </div>
              <div className="flex items-center gap-1">
                {order.issuedBy && (
                  <>
                    <span className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">Issued By: </span>
                    <img
                      src={getAvatarUrl(order.issuedBy.avatar)}
                      className="w-[20px] rounded-[10px] cursor-pointer ml-2"
                    />
                    <span className="font-OpenSansRegular text-[12px] text-titleColor">{order.issuedBy.name}</span>
                  </>
                )}
              </div>
              {/* {order.requestedUser && order.status < 2 && (
                <>
                  <span className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">Requested By: </span>
                  <img
                    src={getAvatarUrl(order.requestedUser.avatar)}
                    className="w-[20px] rounded-[10px] cursor-pointer ml-2"
                  />
                  <span className="font-OpenSansRegular text-[12px] text-titleColor">{order.requestedUser.name}</span>
                </>
              )} */}
            </div>
          </div>
        </div>

        <div className="w-full flex items-center justify-between px-3 ">
          <div className="flex items-center gap-1">
            <span className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">Vendor: </span>
            <span className="font-OpenSansRegular text-[12px] text-titleColor">{order.vendor}</span>
          </div>
        </div>
        <div className="w-full flex items-center justify-between px-3 py-3 ">
          <div className="w-[50%] flex gap-[10px]">
            <div className="max-w-[60%] min-w-[60%] flex-1 flex flex-col gap-2">
              <div className="w-full ">
                <p className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">Description</p>
                <p className="font-OpenSansRegular text-[12px] text-titleColor breakable-text">{order.description}</p>
              </div>
              <div className="w-full ">
                <p className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">Note</p>
                <span className="font-OpenSansRegular text-[12px] text-titleColor breakable-text">{order.note}</span>
              </div>
            </div>
            <div className="flex flex-col">
              <input
                onChange={receiptSelected}
                type="file"
                id="receiptfile"
                ref={receiptInputFile}
                style={{ display: "none" }}
                multiple
                accept="image/*,application/pdf"
              />
              <div className="w-full flex items-center justify-between h-[30px]">
                <p className="font-OpenSansRegular font-[700] text-[12px] text-titleColor ">Attachments:</p>
                {/* {order.attachments && (isClericalOver() || isAccountant()) && (
                  <div className="w-[25px]">
                    <Button onClicked={uploadReceipt} title="+" />
                  </div>
                )} */}
              </div>
              <div
                className={`w-full rounded-[6px] border border-dashed p-3 transition-colors ${isReceiptDragActive && isReceiptDragInvalid
                  ? "border-red-500 bg-red-50"
                  : isReceiptDragActive
                    ? "border-blueColor bg-[#F4F8FF]"
                    : "border-borderColor"
                  }`}
                onDragEnter={handleReceiptDragEnter}
                onDragOver={handleReceiptDragOver}
                onDragLeave={handleReceiptDragLeave}
                onDrop={handleReceiptDrop}
              >
                {order.attachments?.length > 0 ? (
                  <div className="w-full flex-auto overflow-y-auto flex flex-col gap-2">
                    {order.attachments.map((attachment, index) => (
                      <div className="w-full flex items-center gap-3" key={index}>
                        <span
                          onClick={() => previewReceiptAttachment(attachment)}
                          className="font-OpenSansRegular font-[400] text-[11px] text-titleColor cursor-pointer breakable-text"
                        >
                          {getRealFileName(attachment.fileName)}
                        </span>
                        <div className="flex items-center gap-2">
                          <div
                            onClick={() => {
                              if (attachment.fileName.split(".").pop().toLowerCase() === "pdf") {
                                downloadPdf(getPOReceiptUrl(attachment.fileName), getRealFileName(attachment.fileName));
                              } else {
                                downloadImage(getPOReceiptUrl(attachment.fileName), getRealFileName(attachment.fileName));
                              }
                            }}
                            className="cursor-pointer"
                          >
                            <FaDownload color="#010D3D" size={13} />
                          </div>
                          {can("po:deleteAttachment") && (
                            <div
                              className="cursor-pointer"
                              onClick={() => {
                                setAttachmentDeleteModalShown(true);
                                setAttachmentToDeleteId(attachment.id);
                              }}
                            >
                              <MdDelete color="#010D3D" size={16} />
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="font-OpenSansRegular text-[11px] text-subTitleColor">
                    No attachments added yet.
                  </p>
                )}
                {can("po:update") && (
                  <>
                    <p className="mt-2 font-OpenSansRegular text-[10px] text-subTitleColor">
                      Drag and drop files here, or click upload.
                    </p>
                    <div className="mt-2">
                      <WhiteUploadButton isLoading={isUploadingReceipt} clicked={uploadReceipt} />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="w-[50%] h-full flex items-center justify-around">
            <div className="w-[50%] px-4 h-full">
              {/* <p className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">Technician:</p>
              <div className="w-full h-[25px] flex items-center gap-3 px-3 ">
                <span className="font-OpenSansRegular font-[400] text-[11px] text-titleColor cursor-pointer">
                  {order.issuedUser?.name}
                </span>
              </div> */}
              {/* {techNameArray.map((techName, index) => {
                return (
                  <div className="w-full h-[25px] flex items-center gap-3 px-3 " key={index}>
                    <span className="font-OpenSansRegular font-[400] text-[11px] text-titleColor cursor-pointer">{techName}</span>
                  </div>
                );
              })} */}
            </div>
            <div className="w-[50%] h-[100px] flex items-center justify-end">
              {(order.status == 0 || order.status == 1) && currentUser.roles[0].id <= 2 && (
                <div className="flex flex-col items-center gap-1">
                  <ApproveRequestButton onClicked={showPoInputModal} />
                  <DenyRequestButton onClicked={denyRequest} />
                </div>
              )}
            </div>
          </div>
        </div>

        {can("po:update") && (
          <div className="absolute right-2 bottom-1 flex items-center gap-2">
            <PencilButton clicked={editPO} />
          </div>
        )}
      </div>

      <div className="w-full border-solid border-[1px] border-borderColor mt-3">
        <div className="w-full h-[30px]  flex items-center justify-between px-3">
          <span className="font-OpenSansRegular font-[700] text-[16px] text-titleColor ">Items </span>
        </div>

        <div className="w-full border-solid border-t-[1px] border-borderColor px-3 py-1">
          {order.poItems.length > 0 ? (
            <>
              {order.poItems.map((item, index) => (
                <div key={index} className="w-full flex items-center justify-between h-[30px]">
                  <span className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">
                    {item.description}{" "}
                  </span>
                  {item.attachment && (
                    // <a href={getUploadUrl(item.attachment)} target="_blank" download={getRealFileName(item.attachment)}>
                    <div className="h-[25px] flex items-center gap-3 " key={index}>
                      <span
                        className="font-OpenSansRegular font-[400] text-[11px] text-titleColor cursor-pointer"
                        onClick={() => previewPOItemAttachment(item.attachment)}
                      >
                        {getRealFileName(item.attachment)}
                      </span>
                      <div
                        onClick={() => downloadImage(getUploadUrl(item.attachment), getRealFileName(item.attachment))}
                        className="cursor-pointer"
                      >
                        <FaDownload color="#010D3D" size={13} />
                      </div>
                    </div>
                    // </a>
                  )}
                </div>
              ))}
            </>
          ) : (
            <span className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">No items </span>
          )}
        </div>
      </div>
    </div>
  );
}

export default PODetail;
